<template>
  <div>
    <Section>
      <SectionHeader :title="$t('apps.billing.message.billingalerts')"/>
      <FormRow>
        <Col class="col-md-6">
        <Col
          class="col-md-12 no-padding"
          style="height: 24px;">
        {{ $t('apps.billing.message.autobillingmonthlyinvoice') }}
          </Col>
        <div
          class="form-group col-12"
          style="padding: 0px;margin: 0px;height: 35px;">
          <div class="box-input">
            <vs-checkbox
              v-model="is_enabled_monthly_invoice_charge"
              color="#A3CA76"
              style="float: left;position: relative;top: 1px;left: -5px;"
            >
              <span v-if="is_enabled_monthly_invoice_charge">{{ $t('message.yes') }}</span>
              <span v-else>{{ $t('message.no') }}</span>
            </vs-checkbox>
          </div>
        </div>
        </Col>
      </FormRow>
      <FormRow>
        <Col class="col-md-6">
        <Col
          class="col-md-12 no-padding"
          style="height: 24px;">
        {{ $t('apps.billing.message.receiveemailalerts') }}
          </Col>
        <div
          class="form-group col-12"
          style="padding: 0px;margin: 0px;height: 35px;">
          <div class="box-input">
            <vs-checkbox
              v-model="is_enabled_receive_invoice_email"
              color="#A3CA76"
              style="float: left;position: relative;top: 1px;left: -5px;"
            >
              <span v-if="is_enabled_receive_invoice_email">{{ $t('message.yes') }}</span>
              <span v-else>{{ $t('message.no') }}</span>
            </vs-checkbox>
          </div>
        </div>
        </Col>
      </FormRow>
      <FormRow>
        <Col class="col-md-6">
        <Col
          class="col-md-12 no-padding"
          style="height: 24px;">
        {{ $t('apps.billing.message.receivemessagenotification') }}
          </Col>
        <div
          class="form-group col-12"
          style="padding: 0px;margin: 0px;height: 35px;">
          <div class="box-input">
            <vs-checkbox
              v-model="is_enabled_receive_invoice_notification_desktop"
              color="#A3CA76"
              style="float: left;position: relative;top: 1px;left: -5px;"
            >
              <span v-if="is_enabled_receive_invoice_notification_desktop">{{ $t('message.yes') }}</span>
              <span v-else>{{ $t('message.no') }}</span>
            </vs-checkbox>
          </div>
        </div>
        </Col>
      </FormRow>
    </Section>
    <BaseFormAction
      :textSubmit="$t('button.save')"
      :isSubmitted="false"
      :isHideCloseButton="true"
      @onSubmit="handleSubmit"
    />
  </div>
</template>

<script>
export default {
  props: {
    state: {
      default: () => ({}),
    },
  },

  data () {
    return {
      is_enabled_monthly_invoice_charge: undefined,
      is_enabled_receive_invoice_email: undefined,
      is_enabled_receive_invoice_notification_desktop: undefined,
    }
  },

  mounted () {
    this.is_enabled_monthly_invoice_charge = this.state.is_enabled_monthly_invoice_charge
    this.is_enabled_receive_invoice_email = this.state.is_enabled_receive_invoice_email
    this.is_enabled_receive_invoice_notification_desktop = this.state.is_enabled_receive_invoice_notification_desktop
  },

  methods: {
    async handleSubmit () {
      this.$emit('onSubmit', {
        is_enabled_monthly_invoice_charge: this.is_enabled_monthly_invoice_charge,
        is_enabled_receive_invoice_email: this.is_enabled_receive_invoice_email,
        is_enabled_receive_invoice_notification_desktop: this.is_enabled_receive_invoice_notification_desktop,
      })
    },
  },
}
</script>

<style scoped>
.box-input {
  position: relative;
  padding-left: 7px;
  height: 35px;
  background: #fff;
  border: 1px solid #ced4da;
  color: #495057;
  line-height: 35px;
  border-radius: .25rem;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-input.active {
  background: #e9ecef;
  border-radius: .25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseFormBillingPreference.vue